
export default {
  props: {
    items: {
      type: Array,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  vessel: {
    dot: {
      width: '2xs',
      height: '2xs',
      borderRadius: 'full'
    },
    icon: {
      padding: 'xs',
      fontSize: '2xl',
      backgroundColor: 'white',
      borderRadius: 'full',
      shadow: true
    }
  },
  computed: {
    loadingItems() {
      return [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }]
    },
    buttonAttrs() {
      return {
        color: 'black',
        fontSize: 'lg',
        padding: 'sm'
      }
    }
  }
}
